import { GLOBAL } from '../../../../../config/routes/view-frontend.json';

export default function apiPrefix(prefix: string) {
  return (path: string) => `/:site_name/${GLOBAL.APP_NAME}/${prefix}/${path}`;
}
